import { render, staticRenderFns } from "./WorkIconNavOrdering.vue?vue&type=template&id=72e7024a"
import script from "./WorkIconNavOrdering.vue?vue&type=script&lang=js"
export * from "./WorkIconNavOrdering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports